import { createAction, props } from '@ngrx/store';
import { CustomStockProtectionOverviewList, CustomStockProtectionRequest, SerialNoStatusResponseList } from '../custom-stock-potection.models';

// *****************************************************

export const getStockProtectionOverview = createAction(
    '[Custom Stock Protection] get stock protection overview',
  );

export const getStockProtectionOverviewSuccess = createAction(
    '[Custom Stock Protection] get stock protection overview success',
    props<{ stockProtectionOverview: CustomStockProtectionOverviewList }>()
);
  
export const getStockProtectionOverviewFailure = createAction(
    '[Custom Stock Protection] get stock protection overview failure',
    props<{ error: Error }>()
);

// *****************************************************

export const searchStockProtection = createAction(
    '[Custom Stock Protection] search stock protection',
    props<{
        productCode: string;
        processNumber: string;
        scenarioCode: string;
    }>()
  );

export const searchStockProtectionSuccess = createAction(
    '[Custom Stock Protection] search stock protection success',
    props<{ stockProtectionOverview: CustomStockProtectionOverviewList }>()
);
  
export const searchStockProtectionFailure = createAction(
    '[Custom Stock Protection] search stock protection failure',
    props<{ error: Error }>()
);

// *****************************************************

export const clearStockProtectionOverview = createAction(
    '[Custom Stock Protection] clear stock protection overview'
  );

// *****************************************************

export const getStockProtectionDetails = createAction(
    '[Custom Stock Protection] get stock protection details',
    props<{ processNumber: string; }>()
);

export const getStockProtectionDetailsSuccess = createAction(
    '[Custom Stock Protection] get stock protection details success',
    props<{ stockProtectionDetails: SerialNoStatusResponseList }>()
);
  
export const getStockProtectionDetailsFailure = createAction(
    '[Custom Stock Protection] get stock protection details failure',
    props<{ error: Error }>()
);

// *****************************************************

export const updateSerialNumbers = createAction(
    '[Custom Stock Protection] update serial numbers',
    props<{ 
        processNumber: string;
        serialNumbers: string[];
    }>()
);

export const updateSerialNumbersSuccess = createAction(
    '[[Custom Stock Protection] update serial numbers success',
    props<{ stockProtectionDetails: SerialNoStatusResponseList }>()
);
  
export const updateSerialNumbersFailure = createAction(
    '[Custom Stock Protection] update serial numbers failure',
    props<{ error: Error }>()
);